import styled from '@emotion/styled'
import CommonModal from '@/components/common/Modal'
import { Form, Select as AntSelect } from 'antd'
import { Body } from '../../../PolicyDetailPage/BillingInformation/styles'
import { CloseOutlined } from '@ant-design/icons'

export const Modal = styled(CommonModal)<any>`
  .ant-modal-title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.004em;
    color: #000000;
    height: 50%;
  }

  .ant-btn-default {
    box-shadow: none;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
  }

  .ant-btn-primary {
    box-shadow: none;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
  }

  .ant-modal-header {
    padding: 24px;
    margin-bottom: -1px;
  }

  .ant-modal-body {
    padding: 0px !important;
  }

  .ant-modal-content {
    padding: 0px;
  }
`

export const FormItem = styled(Form.Item)`
  margin-bottom: 16px;

  label {
    font-family: 'Prompt';
    font-style: normal;
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #000000;
  }

  .ant-form-item-label {
    margin: 0;
    padding: 0 0 4px;
    white-space: initial;
    text-align: start;
  }

  .ant-form-item-explain {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.004em;
    color: #666666;
    margin-top: 4px;
    margin-bottom: 16px;
  }
`

export const SearchWrapper = styled('div')`
  display: grid;
`

export const Select = styled(AntSelect)`
  .ant-select-selector {
    height: 42px !important;
    padding: 8px 16px !important;
    border-radius: 8px !important;
  }

  .ant-select-selection-item {
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }

  .ant-select-selection-search-input {
    height: 42px !important;
  }
`

export const StyledUsernamespan = styled.span`
  color: black;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`

export const StyledUserInfo = styled.div`
  flex: 1 1 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`

export const StyledUser = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
  border-bottom: 0.5px #e5e5e5 solid;
  justify-content: flex-start;
  gap: 16px;
  padding-bottom: 10px;
  height: 60px;
`

export const StyledUserName = styled.div`
  color: black;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`

export const BodyStyled = styled(Body)`
  display: grid;
  padding: 20px 24px 0px 24px;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Label = styled.span`
  color: black;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`

export const RequestWrapper = styled.span`
  color: #ef2605;
  font-size: 14px;
  font-family: Prompt;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`

export const FormSelectWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 24px;
  align-items: baseline;
  grid-gap: 8px;
  justify-content: center;
`

export const CloseOutlinedIcon = styled(CloseOutlined)`
  color: #adadad;
  font-size: 16px;
  cursor: pointer;
  
  &:hover {
    color: #666666;
  }
`

export const AntSelectStyled = styled(AntSelect)`
  width: 100%;

  .ant-select-selector {
    height: 42px !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    position: relative;
  }

  .ant-select-selection-item {
    font-size: 14px !important;
  }

  /* Hide the default selection display when we have custom content */
  &.custom-display .ant-select-selection-item {
    display: none;
  }

  /* Adjust height for custom displays */
  &.hospital-select .ant-select-selector {
    height: 60px !important;
  }

  &.disease-select .ant-select-selector {
    height: 80px !important;
  }

  /* Dropdown styling */
  .ant-select-dropdown {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  .ant-select-item {
    border-radius: 0 !important;
  }

  .ant-select-item:first-child {
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .ant-select-item:last-child {
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }
`
